import type { PropsWithChildren, ReactElement } from 'react';
import {
  type EmbeddedPaymentElementConfiguration,
  type IntentConfiguration,
} from '@stripe/stripe-react-native';

export type StripePaymentProviderProps = {
  children: ReactElement | ReactElement[];
  publicKey: string;
  amount: number;
  sessionId?: string;
  disablePolling?: boolean;

  /**
   * Used to remount the Stripe element after failures, must be incremented on each attempt.
   * Failure to do so will result in the Stripe element being stuck / empty.
   */
  purchaseAttempt: number;
};

export type StripePaymentElementProps = {
  children: PropsWithChildren['children'];
  embeddedPaymentElementView?: ReactElement | null;
  show: boolean;
};

export type UseStripePaymentProps = {
  isPaymentStatePollingEnabled: boolean;
  total: number;
  paymentMethods: readonly PaymentMethod[];
  stripeIntentConfig: IntentConfiguration | null;
  stripeElementConfig: EmbeddedPaymentElementConfiguration | null;
};

export type PaymentMethod = {
  id: string;
  description: string | null;
  nickname: string | null;
  cardType: PaymentMethodType;
  isDefault: boolean;
};

export enum PaymentMethodType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Amex = 'AMEX',
  Discover = 'DISCOVER',
  MasterCard = 'MASTER_CARD',
  Visa = 'VISA',
  Unsupported = 'UNSUPPORTED',
}
